import React, { useState } from 'react';
import './Questionnaire.css';
import Explore2 from './Explore2';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import BookExpert from './BookExpert';
import Login from '../Login/Login';

const Questionnaire = () => {
  const [selectedOption, setSelectedOption] = useState('Single');
  const [showExplore2, setShowExplore2] = useState(false);
  const [showBookExpert, setShowBookExpert] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    // Chuyển sang Explore 2 sau khi chọn
    setTimeout(() => {
      setShowExplore2(true);
    }, 300);
  };

  // If user clicked Organizations, show BookExpert
  if (showBookExpert) {
    return <BookExpert />;
  }

  // If user clicked Login, show Login page
  if (showLogin) {
    return <Login />;
  }

  // Nếu đã chọn option, hiển thị Explore2
  if (showExplore2) {
    return <Explore2 />;
  }

  const relationshipOptions = [
    'Single',
    'In a relationship',
    'Married',
    'Divorced',
    'Widowed/er',
    "It's complicated"
  ];

  return (
    <div className="questionnaire-container page-with-header">
      <Header 
        showBookExpert={showBookExpert} 
        setShowBookExpert={setShowBookExpert}
        showLogin={showLogin}
        setShowLogin={setShowLogin}
      />

      {/* Main Content */}
      <div className="main-content">
        <div className="white-container">
          <div className="content-wrapper">
            <h1 className="main-title">Help us get to know you</h1>
            <p className="subtitle">Please answer the following questions.</p>
            
            <div className="question-section">
              <h2 className="question">
                What is your relationship status?
              </h2>
              
              <div className="options-container">
                {relationshipOptions.map((option, index) => (
                  <button
                    key={index}
                    className={`option-button ${selectedOption === option ? 'selected' : ''}`}
                    onClick={() => handleOptionSelect(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Chat Icon */}
      <div className="chat-icon">
        <div className="monitor">
          <div className="screen">
            <div className="face">
              <div className="eyes">
                <span className="eye">"</span>
                <span className="eye">"</span>
              </div>
              <div className="mouth">)</div>
            </div>
          </div>
          <div className="base"></div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Questionnaire;

